import React from 'react';
import ParentWaiversLog from '../../modules/parent/WaiversLog';
import Settings from '../../modules/settings';
import ParentDashboard from '../../modules/parent/Dashboard';
const Products = React.lazy(() => import('../../modules/parent/Products'));

const ProductListing = React.lazy(() =>
  import('../../modules/parent/Products/ProductListing'),
);
const ProgramDetail = React.lazy(() =>
  import('../../modules/parent/Programs/ProgramDetail'),
);
const PackageDetail = React.lazy(() =>
  import('../../modules/parent/Packages/PackageDetail'),
);
const ProductDetail = React.lazy(() =>
  import('../../modules/parent/Products/ProductDetail'),
);
const OrdersHistory = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Orders'),
);
const ThridCalendar = React.lazy(() =>
  import('../../modules/thirdParty/calendar'),
);
const Cart = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Carts'),
);
const Checkout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout'),
);
const CardDetails = React.lazy(() =>
  import('../../modules/admin/CreditSystem/ManageCards'),
);
const CreditWallet = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditWallets'),
);
const CreditHistory = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditsHistory'),
);
const UserReports = React.lazy(() =>
  import('../../modules/admin/ReportManagement/UserReports'),
);
const AccountPage = React.lazy(() =>
  import('../../modules/student/AccountInfo'),
);
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);

const StripeForm = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation/stripe'),
);
const FailedPayment = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/FailedTranscation'),
);
const SettingsPage = React.lazy(() =>
  import('../../modules/student/SettingsPage'),
);
const EventSchedules = React.lazy(() =>
  import('../../modules/student/EventSchedules'),
);
const ManageDomains = React.lazy(() =>
  import('../../../../../libs/MobileComponents/ManageDomainsMob'),
);
const LockerPage = React.lazy(() =>
  import('../../../../../libs/modules/src/lib/account/MyProfile/LockerPage'),
);
const ProductWizardPage = React.lazy(() =>
  import('../../modules/ProductWizardPage'),
);
const AutoLinks = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks'),
);
const AddToCart = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks/AddToCart'),
);
const AddToCartProduct = React.lazy(() =>
  import('../../modules/admin/Products/ProductLinks/AddToCartProduct'),
);
const SettingsTabMob = React.lazy(() =>
  import('../../../../../libs/MobileComponents/SettingsTabMob'),
);
const TransactionHistoryMob = React.lazy(() =>
  import('../../../../../libs/MobileComponents/TransactionHistoryMob'),
);
const PackageWidget = React.lazy(() => import('../../modules/PackageWidget'));
const Error403 = React.lazy(() => import('../../modules/errorPages/Error403'));
const TilledCheckout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout-tilled'),
);
const TransactionHistory = React.lazy(() =>
  import('../../modules/parent/TransactionHistory'),
);
const UnSubscribePage = React.lazy(() =>
  import('../../modules/account/MyProfile/UnSubscribe'),
);
const MissedPaymentCard = React.lazy(() =>
  import('../../modules/student/MissedPaymentCard'),
);
const parentPagesConfigs = (checkMissedPayment, userRole, isMobile) => {
  let studentRoute = [ 
  {
    path: '/parent/product-listing',
    element: <ProductListing />,
  },
  {
    path: '/parent/products',
    element: <Products />,
  },
  {
    path: '/product-details/:productId',
    element: <ProductDetail />,
  },
  {
    path: '/parent/program-details/:programId',
    element: <ProgramDetail />,
  },
  {
    path: '/package-details/:packageId',
    element: <PackageDetail />,
  },
  {
    path: '/parent/orders-history/',
    element: <OrdersHistory />,
  },
  {
    path: '/parent/error-pages/error-403',
    element: <Error403 />,
  },
  {
    path: '/parent/activity-calendar',
    element: <ThridCalendar />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/checkout',
    element: <Checkout />,
  },
  {
    path: '/parent/card-details',
    element: <CardDetails />,
  },
  {
    path: '/parent/credit-wallets',
    element: <CreditWallet />,
  },
  {
    path: '/parent/credit-history',
    element: <CreditHistory />,
  },
  {
    path: '/parent/user-reports',
    element: <UserReports />,
  },
  {
    path: '/order/confirmation/:transId',
    element: <OrderConfirmation />,
  },
  {
    path: '/stripe',
    element: <StripeForm />,
  },
  {
    path: '/order/failed/:transId',
    element: <FailedPayment />,
  },
  {
    path: '/my-profile',
    element: <LockerPage />,
  },
  {
    path: '/parent/settings',
    element: <SettingsPage />,
  },
  {
    path: '/parent/events',
    element: <EventSchedules />,
  },
  {
    path: '/widgets/products/:productSlug',
    element: <ProductWizardPage />,
  },
  {
    path: '/widgets/packages/:packageSlug',
    element: <PackageWidget />,
  },
  {
    path: '/parent/my-account',
    element: <AccountPage />,
  },
  {
    path: '/purchasePackage/:purchaseId/:packageId',
    element: <AutoLinks />,
  },
  {
    path: '/purchasePackage/addtocart/:purchaseId/:packageId',
    element: <AddToCart />,
  },
  {
    path: '/product/addtocart/:purchaseId/:productId',
    element: <AddToCartProduct />,
  },
  {
    path: '/checkout-tilled',
    element: <TilledCheckout />,
  },
  {
    path: '/parent/waivers-log',
    element: <ParentWaiversLog />,
  },
  {
    path: '/transaction-history',
    element: <TransactionHistory />,
  },
  {
    path: '/user/unsubscribe',
    element: <UnSubscribePage />,
  },
  {
    path: '/parent/domains',
    element: <ManageDomains />,
  },
  {
    path: '/parent/settingsTab',
    element: <SettingsTabMob />,
  },
  {
    path: '/transactionHistoryMob',
    element: <TransactionHistoryMob />,
  },
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/dashboard',
    element: <ParentDashboard restrictDashboard={checkMissedPayment} />,
  },
];

  if (checkMissedPayment && !isMobile) {
    studentRoute = [
      {
        path: '/dashboard',
        element: <ParentDashboard restrictDashboard={checkMissedPayment} />,
      },
    ];
  } else if (checkMissedPayment && isMobile) {
    studentRoute = [
      {
        path: `${userRole}/events`,
        element: <MissedPaymentCard />,
      },
    ];
  }
  return studentRoute;
}
export default parentPagesConfigs;